module.exports = __webpack_public_path__ + "assets/img/s1_tab2_active_m.48db10e7.png";